import { useState, useEffect } from 'react'

const FALLBACK_RATES = { COP: 1, USD: 0.00024, CAD: 0.00033 }
const LOCALES = {
  COP: { locale: 'es-CO', code: 'COP' },
  USD: { locale: 'en-US', code: 'USD' },
  CAD: { locale: 'en-CA', code: 'CAD' },
}

export function useCurrency() {
  const [currency, setCurrency] = useState(
    localStorage.getItem('app-currency') || 'COP'
  )
  const [rates, setRates] = useState(FALLBACK_RATES)

  // ✅ DENTRO de la función
  const [lastUpdated, setLastUpdated] = useState(
    localStorage.getItem('currency_rates_time')
      ? Number(localStorage.getItem('currency_rates_time'))
      : null
  )

  useEffect(() => {
    async function fetchRates() {
      try {
        const cached = localStorage.getItem('currency_rates')
        const cachedTime = localStorage.getItem('currency_rates_time')
        const sixHours = 6 * 60 * 60 * 1000

        if (cached && cachedTime && Date.now() - Number(cachedTime) < sixHours) {
          setRates(JSON.parse(cached))
          return
        }

        const res = await fetch('https://api.exchangerate-api.com/v4/latest/COP')
        const data = await res.json()
        const newRates = { COP: 1, USD: data.rates.USD, CAD: data.rates.CAD }

        localStorage.setItem('currency_rates', JSON.stringify(newRates))
        localStorage.setItem('currency_rates_time', String(Date.now()))
        setRates(newRates)
        setLastUpdated(Date.now())
      } catch {
        // fallback silencioso
      }
    }
    fetchRates()
  }, [])

  useEffect(() => {
    const handler = (e) => setCurrency(e.detail)
    window.addEventListener('currencyChange', handler)
    return () => window.removeEventListener('currencyChange', handler)
  }, [])

  function format(amountInCOP) {
    const rate = rates[currency] ?? 1
    const { locale, code } = LOCALES[currency]
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      maximumFractionDigits: 0
    }).format(amountInCOP * rate)
  }

  return { currency, rates, format, lastUpdated }
}